import colors from './colors';
const borders = {
  inputs: `1px solid ${colors.neutralLight};`,
  error: `1px solid ${colors.error};`,
  section: `2px solid ${colors.primaryMain}`,
  dashed: `1.5px dashed ${colors.neutralGrey};`,
  card: `1px solid ${colors.neutralLight};`,
  radius: '6px',
  radiusLarge: '12px',
};

export default borders;
